import React, {useContext,useEffect,useState} from 'react'
import Axios from 'axios';
import {Card, CardHeader, CardContent, Typography, Button} from '@mui/material'
import Box from '@mui/material/Box';
import { formularioContext } from '../contextos/FormularioContext'
import Swal from 'sweetalert2';
import CircularProgress from '@mui/material/CircularProgress';
import { GrupoPersonas } from './GrupoPersonas';
import { ETPagando } from './ETPagando';

export const ETPago = ({datos,
                generarPreferencia,
                id_evento,
                eventoSeleccionado,
                descripcionProvincia,
                datosMinistroUad,
                buscarHabilitacionExterno,
                eventoValorSeleccionado,
                cancelar
            })=>{
    const [productos,setProductos] = React.useState([])
    const [valor,setValor] = React.useState(null)
    const [clickReady,setClickReady] = React.useState(false)
    const [pagando,setPagando] = React.useState(false)
    const {grupo,datosMinistroOk,datosConyugeOk,detalleCompra} = useContext(formularioContext)


    useEffect(()=>{
        setClickReady(false);
        setTimeout(() => {
           setClickReady(true) 
        }, 2000);
    },[valor])

    const buscarEventosValor = async (id_evento)=>{
        try{
            const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/tablasgenerales/eventosvalor/${id_evento}`:`https://uadapi.uad.digital/api/tablasgenerales/eventosvalor/${id_evento}`)
            setProductos(data)
            setValor(data[0]?.id_evento_valor?.toString())
        }catch(err){
            alert(err)
        }
    }

    useEffect(()=>{
        buscarEventosValor(id_evento)
        setTimeout(() => {
        }, 200);
    },[])

    const pagarOk = ()=>{
        const inscripto_principalOk = datosMinistroOk()[0]==true;
        const conyugeOk = (!datos.esMatrimonial || (datos.esMatrimonial && datosConyugeOk()[0]))
        const cant_personas_extras = Number(datos.cant_max_personas)-1;
        const otrosInscriptosOk = Number(datos.cant_max_personas)==1 || (Number(datos.cant_max_personas) > 1 && (cant_personas_extras==Number(grupo.length)))
        return inscripto_principalOk && otrosInscriptosOk && conyugeOk
    }

    return <Box sx={{marginTop: -4, display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
    {<>
        <div style={{
                    display:'flex',
                    flexDirection:'column',
                    flexWrap:'wrap',
                    gap:'5px', 
                    justifyContent:'center',
                    alignItems:'center',
                    padding:'5px'}}>  
            {(Number(datos.cant_max_personas) > 1) && <GrupoPersonas/>}
        </div>
          {pagarOk() && <ETPagando
            item_a_pagar={productos.filter(i=>i.id_evento_valor==eventoValorSeleccionado.id_evento_valor)[0]}
            abrir={pagando}
            cancelar={cancelar}
            venta={datos}
            datosMinistroUad={datosMinistroUad}
            descripcionProvincia={descripcionProvincia}
            eventoSeleccionado={eventoSeleccionado}
            generarPreferencia={generarPreferencia}
        />}
    </>}
</Box>
}

